export default __webpack_public_path__ + "static/media/football.5a696342.png";